var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-5",attrs:{"id":"Content"}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 col-xl-4"},[_c('Verification')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }